export enum ReliabilityRogueStatus {
  Open = 1,
  Confirmed = 2,
  Rejected = 3,
  NotRogue = 4,
}

export const ReliabilityRogueChoices = [
  { key: "OPEN", value: ReliabilityRogueStatus.Open },
  { key: "CONFIRMED", value: ReliabilityRogueStatus.Confirmed },
  { key: "REJECTED", value: ReliabilityRogueStatus.Rejected },
  { key: "NOT ROGUE", value: ReliabilityRogueStatus.NotRogue },
];
